import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Textarea/Display.tsx
var TextareaFieldDisplay = ({ config }) => {
	const { valuesByFieldId } = useFormBuilderFieldsContext();
	const value = valuesByFieldId[config.id];
	if (!value) return null;
	return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs(Label, { children: [config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {}), config.options.displayLabel] }), /* @__PURE__ */ jsx("div", {
			className: "whitespace-pre-line",
			children: value
		})] })
	});
};
//#endregion
export { TextareaFieldDisplay };

//# sourceMappingURL=Display.js.map